// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Collapsible section toggle */
.dp-ph__section-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 7px 10px;
  background: #f0f3f8;
  border: none;
  border-bottom: 1px solid var(--dp-color-border);
  cursor: pointer;
  text-align: left;
  transition: background 0.12s;
}
.dp-ph__section-toggle:hover { background: #e5eaf4; }
.dp-ph__section-toggle:hover .dp-ph__section-chevron { color: var(--dp-color-primary); }

.dp-ph__section-chevron {
  font-size: 10px;
  color: var(--dp-color-text-secondary);
  width: 10px;
  flex-shrink: 0;
  transition: color 0.12s;
}

.dp-ph__section-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--dp-color-text);
  flex: 1;
}

.dp-ph__section-counts {
  display: flex;
  gap: 4px;
}

.dp-ph__count-chip {
  font-size: 10px;
  color: var(--dp-color-text-secondary);
  background: #dde3ef;
  border-radius: 10px;
  padding: 1px 6px;
}

.dp-ph__section-body {
  background: var(--dp-color-background);
}

/* Tabs */
.dp-ph__tabs {
  display: flex;
  gap: 0;
  margin-bottom: var(--dp-spacing-sm);
  border-bottom: var(--dp-border-width-medium) solid var(--dp-color-border);
}

.dp-ph__tab {
  flex: 1;
  padding: var(--dp-spacing-sm) var(--dp-spacing-md);
  border: none;
  background: none;
  cursor: pointer;
  font-size: var(--dp-font-size-sm);
  color: var(--dp-color-text-secondary);
  font-weight: var(--dp-font-weight-semibold);
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.15s;
}

.dp-ph__tab:hover {
  color: var(--dp-color-text);
}

.dp-ph__tab--active {
  color: var(--dp-color-primary);
  border-bottom-color: var(--dp-color-primary);
}

/* Toolbar */
.dp-ph__toolbar {
  display: flex;
  gap: var(--dp-spacing-xs);
  margin-bottom: var(--dp-spacing-sm);
  align-items: center;
}

.dp-ph__search {
  flex: 1;
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-sm);
  outline: none;
}

.dp-ph__search:focus {
  border-color: var(--dp-color-primary);
}

/* Buttons */
.dp-ph__btn {
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  cursor: pointer;
  background: var(--dp-color-background);
  color: var(--dp-color-text);
  white-space: nowrap;
  transition: all 0.12s;
}

.dp-ph__btn:hover {
  background: var(--dp-color-surface-hover);
}

.dp-ph__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dp-ph__btn--primary {
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
  border-color: var(--dp-color-primary);
}

.dp-ph__btn--primary:hover {
  background: var(--dp-color-primary-hover);
}

.dp-ph__btn--icon {
  padding: var(--dp-spacing-xs);
  font-size: var(--dp-font-size-md);
  line-height: 1;
}

.dp-ph__btn--insert,
.dp-ph__btn--select {
  padding: 2px 8px;
  font-size: 11px;
  background: var(--dp-color-surface);
  border-color: var(--dp-color-primary);
  color: var(--dp-color-primary);
}

.dp-ph__btn--insert:hover,
.dp-ph__btn--select:hover {
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
}

/* Form header (shared across create modes) */
.dp-ph__form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--dp-spacing-sm);
}

.dp-ph__form-title {
  font-size: var(--dp-font-size-sm);
  font-weight: var(--dp-font-weight-bold);
  color: var(--dp-color-text);
}

.dp-ph__form-desc {
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text-secondary);
  margin: 0 0 var(--dp-spacing-sm);
  line-height: 1.4;
}

.dp-ph__form-close {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--dp-color-text-secondary);
  font-size: 12px;
  padding: 2px 5px;
  line-height: 1;
  border-radius: var(--dp-border-radius-sm);
}
.dp-ph__form-close:hover { background: var(--dp-color-surface-hover); color: var(--dp-color-text); }

/* Create form */
.dp-ph__create-form {
  background: var(--dp-color-surface);
  padding: var(--dp-spacing-sm);
  border-radius: var(--dp-border-radius-md);
  margin-bottom: var(--dp-spacing-sm);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
}

.dp-ph__form-row {
  display: flex;
  gap: var(--dp-spacing-xs);
  margin-bottom: var(--dp-spacing-xs);
  align-items: center;
}

.dp-ph__form-row:last-child {
  margin-bottom: 0;
}

.dp-ph__input {
  flex: 1;
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
}

.dp-ph__input:focus {
  border-color: var(--dp-color-primary);
  outline: none;
}

.dp-ph__select {
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  background: var(--dp-color-background);
}

/* Searchable dropdown */
.dp-dt-search {
  position: relative;
  margin-bottom: var(--dp-spacing-xs);
}

/* Trigger button (looks like a select) */
.dp-dt-search__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  background: var(--dp-color-background);
  cursor: pointer;
  text-align: left;
}
.dp-dt-search__trigger:hover {
  border-color: var(--dp-color-primary);
}
.dp-dt-search__trigger-text {
  color: var(--dp-color-text);
}
.dp-dt-search__trigger-placeholder {
  color: var(--dp-color-text-secondary);
}
.dp-dt-search__trigger-arrow {
  font-size: 8px;
  color: var(--dp-color-text-secondary);
  margin-left: 8px;
}

/* Dropdown panel */
.dp-dt-search__dropdown {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  z-index: 10;
  background: var(--dp-color-background);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
}

/* Search input pinned at top */
.dp-dt-search__search-box {
  display: flex;
  align-items: center;
  padding: 6px 8px;
  border-bottom: 1px solid var(--dp-color-border);
  background: var(--dp-color-surface);
}
.dp-dt-search__search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: var(--dp-font-size-xs);
  background: transparent;
  color: var(--dp-color-text);
  padding: 2px 0;
}
.dp-dt-search__search-input::placeholder {
  color: var(--dp-color-text-secondary);
}
.dp-dt-search__search-clear {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--dp-color-text-secondary);
  font-size: 10px;
  padding: 2px 4px;
  line-height: 1;
}
.dp-dt-search__search-clear:hover {
  color: var(--dp-color-text);
}

/* Scrollable list */
.dp-dt-search__list {
  max-height: 180px;
  overflow-y: auto;
}

.dp-dt-search__empty {
  padding: 12px;
  color: var(--dp-color-text-secondary);
  font-size: var(--dp-font-size-xs);
  text-align: center;
}

.dp-dt-search__group-header {
  padding: 5px 10px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--dp-color-text-secondary);
  background: #f0f3f8;
  border-bottom: 1px solid var(--dp-color-border);
  position: sticky;
  top: 0;
}

.dp-dt-search__item {
  padding: 5px 10px 5px 20px;
  cursor: pointer;
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text);
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background 0.1s;
}
.dp-dt-search__item:hover {
  background: var(--dp-color-surface-hover);
}
.dp-dt-search__item--selected {
  background: #e8f0fe;
  font-weight: 600;
  color: var(--dp-color-primary);
}
.dp-dt-search__item--selected:hover {
  background: #d2e3fc;
}
.dp-dt-search__check {
  font-size: 11px;
  color: var(--dp-color-primary);
}

.dp-dt-search__backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
}

.dp-ph__checkbox-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text-secondary);
  flex: 1;
}

/* Drag hint */
.dp-ph__drag-hint {
  text-align: center;
  padding: var(--dp-spacing-xs);
  font-size: 10px;
  color: var(--dp-color-text-secondary);
  background: var(--dp-color-surface);
  border-radius: var(--dp-border-radius-sm);
  margin-bottom: var(--dp-spacing-xs);
}

/* List */
.dp-ph__list {
  display: flex;
  flex-direction: column;
}

.dp-ph__item {
  display: flex;
  align-items: center;
  gap: var(--dp-spacing-xs);
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);
  transition: background 0.12s;
  cursor: grab;
}

.dp-ph__item:hover {
  background: var(--dp-color-surface);
}

.dp-ph__item:active {
  cursor: grabbing;
}

.dp-ph__item[draggable="true"]:hover {
  background: #e8eaf6;
}

.dp-ph__item--inserted {
  background: #e8f5e9;
  animation: dp-ph-flash 2s ease-out;
}

@keyframes dp-ph-flash {
  0% { background: #c8e6c9; }
  100% { background: transparent; }
}

/* Clickable + draggable items */
.dp-ph__item--clickable {
  cursor: grab;
}
.dp-ph__item--clickable:active {
  cursor: grabbing;
}
.dp-ph__item--clickable:hover {
  background: #e8f0fe;
}

/* Drag handle */
.dp-ph__drag-handle {
  color: var(--dp-color-text-secondary);
  font-size: 12px;
  line-height: 1;
  opacity: 0.3;
  flex-shrink: 0;
  user-select: none;
  letter-spacing: 1px;
}

.dp-ph__item:hover .dp-ph__drag-handle {
  opacity: 0.7;
}

.dp-ph__item-main {
  flex: 1;
  min-width: 0;
}

.dp-ph__item-key {
  display: block;
  font-family: monospace;
  font-size: var(--dp-font-size-xs);
  font-weight: var(--dp-font-weight-semibold);
  color: var(--dp-color-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dp-ph__item-label {
  display: block;
  font-size: 10px;
  color: var(--dp-color-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dp-ph__item-meta {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.dp-ph__item-value {
  font-size: 10px;
  color: var(--dp-color-text-secondary);
  max-width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Type badges */
.dp-ph__type-badge {
  font-size: 9px;
  font-weight: var(--dp-font-weight-bold);
  padding: 1px 5px;
  border-radius: var(--dp-border-radius-sm);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.dp-ph__type-badge--text    { background: #e3f2fd; color: #1565c0; }
.dp-ph__type-badge--date    { background: #f3e5f5; color: #7b1fa2; }
.dp-ph__type-badge--number  { background: #e8f5e9; color: #2e7d32; }
.dp-ph__type-badge--money   { background: #fff8e1; color: #f57f17; }
.dp-ph__type-badge--boolean { background: #fce4ec; color: #c62828; }
.dp-ph__type-badge--address { background: #e0f2f1; color: #00695c; }
.dp-ph__type-badge--list    { background: #ede7f6; color: #4527a0; }
.dp-ph__type-badge--unknown { background: #f5f5f5; color: #757575; }

.dp-ph__required-badge {
  font-size: 9px;
  font-weight: var(--dp-font-weight-bold);
  padding: 1px 4px;
  border-radius: var(--dp-border-radius-sm);
  background: #ffebee;
  color: #c62828;
}

.dp-ph__in-doc-badge {
  font-size: 11px;
  color: #2e7d32;
  font-weight: bold;
}

/* Status */
.dp-ph__status {
  text-align: center;
  padding: var(--dp-spacing-md);
  color: var(--dp-color-text-secondary);
  font-size: var(--dp-font-size-sm);
}

.dp-ph__error {
  padding: var(--dp-spacing-sm);
  background: #fde8e8;
  color: var(--dp-color-error);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  margin-bottom: var(--dp-spacing-sm);
}

.dp-ph__empty {
  text-align: center;
  padding: var(--dp-spacing-lg);
  color: var(--dp-color-text-secondary);
  font-size: var(--dp-font-size-sm);
}

.dp-ph__summary {
  margin-top: var(--dp-spacing-sm);
  text-align: center;
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text-secondary);
}

/* ── Keyword dual-list ── */
.dp-kw__dual {
  display: flex;
  gap: 6px;
  margin-bottom: var(--dp-spacing-xs);
}

.dp-kw__col {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  overflow: hidden;
}

.dp-kw__col-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 6px;
  background: #f0f3f8;
  font-size: 10px;
  font-weight: var(--dp-font-weight-semibold);
  color: var(--dp-color-text-secondary);
  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);
}

.dp-kw__move-all {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  color: var(--dp-color-primary);
  padding: 0 2px;
  line-height: 1;
}
.dp-kw__move-all:hover { color: var(--dp-color-primary-hover); }

.dp-kw__list {
  flex: 1;
  overflow-y: auto;
  max-height: 150px;
}

.dp-kw__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 6px;
  font-size: 11px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  gap: 4px;
  transition: background 0.1s;
}
.dp-kw__item:hover { background: #eef1fb; }
.dp-kw__item:last-child { border-bottom: none; }

.dp-kw__item--selected { background: #f0fff4; }
.dp-kw__item--selected:hover { background: #e0f5e9; }

.dp-kw__add  { color: var(--dp-color-primary); font-size: 14px; flex-shrink: 0; }
.dp-kw__remove { color: #c62828; font-size: 10px; flex-shrink: 0; }

/* ── Advanced Condition builder ── */
.dp-ac__rows {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: var(--dp-spacing-xs);
}

.dp-ac__row {
  background: #f8f9fc;
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dp-ac__row-label {
  font-size: 10px;
  font-weight: var(--dp-font-weight-bold);
  color: var(--dp-color-primary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  flex-shrink: 0;
}

.dp-ac__row-fields {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dp-ac__select--ph,
.dp-ac__select--op {
  width: 100%;
}

.dp-ac__input--val {
  flex: 1;
}

.dp-ac__then-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.dp-ac__remove-row {
  background: none;
  border: none;
  cursor: pointer;
  color: #c62828;
  font-size: 10px;
  padding: 2px 4px;
  border-radius: var(--dp-border-radius-sm);
  flex-shrink: 0;
}
.dp-ac__remove-row:hover { background: #fde8e8; }

.dp-ac__add-row {
  background: none;
  border: 1px dashed var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  color: var(--dp-color-primary);
  font-size: var(--dp-font-size-xs);
  padding: 4px 8px;
  cursor: pointer;
  text-align: center;
  transition: all 0.12s;
}
.dp-ac__add-row:hover { background: var(--dp-color-surface); border-color: var(--dp-color-primary); }

.dp-ac__else-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px;
  background: #fffbf0;
  border: var(--dp-border-width-thin) solid #ffe082;
  border-radius: var(--dp-border-radius-sm);
}

/* Advanced condition list item (in section body) */
.dp-ac__list-item {
  cursor: default;
}
.dp-ac__list-item:hover {
  background: var(--dp-color-surface);
}

/* ── Document Type section ── */
.dp-dt__assigned-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
}
.dp-dt__assigned-group {
  font-size: 10px;
  font-weight: var(--dp-font-weight-bold);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--dp-color-text-secondary);
}
.dp-dt__assigned-type {
  flex: 1;
  font-size: var(--dp-font-size-sm);
  font-weight: var(--dp-font-weight-semibold);
  color: #155724;
  background: #d4edda;
  padding: 2px 8px;
  border-radius: var(--dp-border-radius-full);
}
.dp-dt__assigned-change {
  background: none;
  border: 1px solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  cursor: pointer;
  color: var(--dp-color-primary);
  font-size: 11px;
  padding: 2px 7px;
  line-height: 1.4;
  white-space: nowrap;
}
.dp-dt__assigned-change:hover {
  background: var(--dp-color-surface-hover);
}

.dp-dt__selected-chip {
  background: #d4edda;
  color: #155724;
  font-weight: var(--dp-font-weight-semibold);
}

.dp-dt__group {
  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);
}
.dp-dt__group:last-child { border-bottom: none; }

.dp-dt__group-header {
  padding: 5px 10px 3px;
  font-size: 10px;
  font-weight: var(--dp-font-weight-bold);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--dp-color-text-secondary);
  background: #f8f9fc;
}

.dp-dt__item {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 7px 12px;
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text);
  cursor: pointer;
  transition: background 0.1s;
  border-bottom: 1px solid #f5f5f5;
}
.dp-dt__item:last-child { border-bottom: none; }
.dp-dt__item:hover { background: #eef1fb; }

.dp-dt__item--selected {
  background: #e8f5e9;
  font-weight: var(--dp-font-weight-semibold);
  color: #1b5e20;
}
.dp-dt__item--selected:hover { background: #dcedc8; }

.dp-dt__radio {
  font-size: 12px;
  color: var(--dp-color-primary);
  flex-shrink: 0;
  width: 14px;
}

.dp-dt__item-name { flex: 1; }

.dp-dt__check {
  color: #2e7d32;
  font-size: 12px;
  font-weight: bold;
  flex-shrink: 0;
}

.dp-dt__clear-row {
  padding: 6px 10px;
  border-top: var(--dp-border-width-thin) solid var(--dp-color-border);
  background: #f8f9fc;
  text-align: right;
}

/* Picker list inside the selector form */
.dp-dt__picker-list {
  max-height: 220px;
  overflow-y: auto;
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  margin-bottom: 2px;
}

/* Template Info Section */
.dp-tpl__info {
  padding: 8px 12px;
}

.dp-tpl__row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 5px 0;
  border-bottom: 1px solid var(--dp-color-border);
}
.dp-tpl__row:last-child {
  border-bottom: none;
}

.dp-tpl__label {
  font-size: 11px;
  font-weight: 700;
  color: var(--dp-color-text);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  min-width: 55px;
  padding-top: 2px;
}

.dp-tpl__value {
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text);
  flex: 1;
  font-weight: 500;
}

.dp-tpl__value--editable {
  cursor: pointer;
  border-radius: var(--dp-border-radius-sm);
  padding: 1px 4px;
  margin: -1px -4px;
}
.dp-tpl__value--editable:hover {
  background: var(--dp-color-surface-hover);
}

.dp-tpl__edit-icon {
  font-size: 9px;
  color: var(--dp-color-primary);
  margin-left: 4px;
  font-weight: 600;
  opacity: 0.6;
}
.dp-tpl__value--editable:hover .dp-tpl__edit-icon {
  opacity: 1;
}

.dp-tpl__name-edit {
  display: flex;
  gap: 4px;
  flex: 1;
  align-items: center;
}
.dp-tpl__name-edit .dp-ph__input {
  flex: 1;
  font-size: 12px;
  padding: 3px 6px;
}
.dp-tpl__name-edit .dp-ph__btn {
  font-size: 10px;
  padding: 3px 8px;
}

/* ── Conditional Section Visual Toggle ── */
.dp-cond__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);
}
.dp-cond__item:last-child {
  border-bottom: none;
}

.dp-cond__badge {
  font-size: 9px;
  font-weight: var(--dp-font-weight-bold);
  padding: 1px 6px;
  border-radius: var(--dp-border-radius-sm);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  flex-shrink: 0;
}
.dp-cond__badge--if {
  background: #d1fae5;
  color: #065f46;
}
.dp-cond__badge--unless {
  background: #fef3c7;
  color: #92400e;
}

.dp-cond__key {
  flex: 1;
  font-family: monospace;
  font-size: var(--dp-font-size-xs);
  font-weight: var(--dp-font-weight-semibold);
  color: var(--dp-color-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

/* CSS-only toggle switch */
.dp-cond__toggle {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
}
.dp-cond__toggle input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.dp-cond__toggle-slider {
  display: inline-block;
  width: 32px;
  height: 18px;
  background: #9CA3AF;
  border-radius: 9px;
  position: relative;
  transition: background 0.2s;
}
.dp-cond__toggle-slider::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}
.dp-cond__toggle input[type="checkbox"]:checked + .dp-cond__toggle-slider {
  background: #10B981;
}
.dp-cond__toggle input[type="checkbox"]:checked + .dp-cond__toggle-slider::after {
  transform: translateX(14px);
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/PlaceholderList.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,+BAA+B,mBAAmB,EAAE;AACpD,uDAAuD,8BAA8B,EAAE;;AAEvF;EACE,eAAe;EACf,qCAAqC;EACrC,WAAW;EACX,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,OAAO;AACT;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,MAAM;EACN,mCAAmC;EACnC,yEAAyE;AAC3E;;AAEA;EACE,OAAO;EACP,kDAAkD;EAClD,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,qCAAqC;EACrC,2CAA2C;EAC3C,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,kDAAkD;EAClD,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA,YAAY;AACZ;EACE,kDAAkD;EAClD,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,eAAe;EACf,sCAAsC;EACtC,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;;EAEE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;AACA,2BAA2B,yCAAyC,EAAE,2BAA2B,EAAE;;AAEnG,gBAAgB;AAChB;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,yCAAyC;EACzC,mCAAmC;EACnC,gEAAgE;AAClE;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,kDAAkD;EAClD,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,kDAAkD;EAClD,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kDAAkD;EAClD,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qCAAqC;AACvC;AACA;EACE,cAAc;EACd,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sCAAsC;EACtC,gEAAgE;EAChE,yCAAyC;EACzC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,mCAAmC;AACrC;AACA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qCAAqC;EACrC,mBAAmB;EACnB,+CAA+C;EAC/C,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,iCAAiC;EACjC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,qCAAqC;EACrC,OAAO;AACT;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,qCAAqC;EACrC,mCAAmC;EACnC,yCAAyC;EACzC,mCAAmC;AACrC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kDAAkD;EAClD,uEAAuE;EACvE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,OAAO,uBAAuB,EAAE;AAClC;;AAEA,gCAAgC;AAChC;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,iCAAiC;EACjC,2CAA2C;EAC3C,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;;AAEnE;EACE,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B,yCAAyC;EACzC,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,QAAQ;EACR,mCAAmC;AACrC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gEAAgE;EAChE,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C,qCAAqC;EACrC,uEAAuE;AACzE;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,8BAA8B;EAC9B,cAAc;EACd,cAAc;AAChB;AACA,yBAAyB,oCAAoC,EAAE;;AAE/D;EACE,OAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,QAAQ;EACR,2BAA2B;AAC7B;AACA,qBAAqB,mBAAmB,EAAE;AAC1C,0BAA0B,mBAAmB,EAAE;;AAE/C,yBAAyB,mBAAmB,EAAE;AAC9C,+BAA+B,mBAAmB,EAAE;;AAEpD,eAAe,8BAA8B,EAAE,eAAe,EAAE,cAAc,EAAE;AAChF,iBAAiB,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE;;AAElE,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,gEAAgE;EAChE,yCAAyC;EACzC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,cAAc;AAChB;AACA,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,gBAAgB;EAChB,yCAAyC;EACzC,yCAAyC;EACzC,8BAA8B;EAC9B,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;AACA,wBAAwB,mCAAmC,EAAE,qCAAqC,EAAE;;AAEpG;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA,mDAAmD;AACnD;EACE,eAAe;AACjB;AACA;EACE,mCAAmC;AACrC;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,uCAAuC;EACvC,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;AACvC;AACA;EACE,OAAO;EACP,iCAAiC;EACjC,2CAA2C;EAC3C,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,yCAAyC;EACzC,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,uEAAuE;AACzE;AACA,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,qBAAqB;EACrB,eAAe;EACf,uCAAuC;EACvC,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,2BAA2B;EAC3B,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;AAClC;AACA,0BAA0B,mBAAmB,EAAE;AAC/C,qBAAqB,mBAAmB,EAAE;;AAE1C;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;AAChB;AACA,+BAA+B,mBAAmB,EAAE;;AAEpD;EACE,eAAe;EACf,8BAA8B;EAC9B,cAAc;EACd,WAAW;AACb;;AAEA,oBAAoB,OAAO,EAAE;;AAE7B;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oEAAoE;EACpE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gEAAgE;EAChE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,OAAO;EACP,mBAAmB;AACrB;AACA;EACE,OAAO;EACP,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kDAAkD;EAClD,uEAAuE;AACzE;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,sBAAsB;EACtB,iCAAiC;EACjC,2CAA2C;EAC3C,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B","sourcesContent":["/* Collapsible section toggle */\n.dp-ph__section-toggle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  padding: 7px 10px;\n  background: #f0f3f8;\n  border: none;\n  border-bottom: 1px solid var(--dp-color-border);\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.12s;\n}\n.dp-ph__section-toggle:hover { background: #e5eaf4; }\n.dp-ph__section-toggle:hover .dp-ph__section-chevron { color: var(--dp-color-primary); }\n\n.dp-ph__section-chevron {\n  font-size: 10px;\n  color: var(--dp-color-text-secondary);\n  width: 10px;\n  flex-shrink: 0;\n  transition: color 0.12s;\n}\n\n.dp-ph__section-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--dp-color-text);\n  flex: 1;\n}\n\n.dp-ph__section-counts {\n  display: flex;\n  gap: 4px;\n}\n\n.dp-ph__count-chip {\n  font-size: 10px;\n  color: var(--dp-color-text-secondary);\n  background: #dde3ef;\n  border-radius: 10px;\n  padding: 1px 6px;\n}\n\n.dp-ph__section-body {\n  background: var(--dp-color-background);\n}\n\n/* Tabs */\n.dp-ph__tabs {\n  display: flex;\n  gap: 0;\n  margin-bottom: var(--dp-spacing-sm);\n  border-bottom: var(--dp-border-width-medium) solid var(--dp-color-border);\n}\n\n.dp-ph__tab {\n  flex: 1;\n  padding: var(--dp-spacing-sm) var(--dp-spacing-md);\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: var(--dp-font-size-sm);\n  color: var(--dp-color-text-secondary);\n  font-weight: var(--dp-font-weight-semibold);\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  transition: all 0.15s;\n}\n\n.dp-ph__tab:hover {\n  color: var(--dp-color-text);\n}\n\n.dp-ph__tab--active {\n  color: var(--dp-color-primary);\n  border-bottom-color: var(--dp-color-primary);\n}\n\n/* Toolbar */\n.dp-ph__toolbar {\n  display: flex;\n  gap: var(--dp-spacing-xs);\n  margin-bottom: var(--dp-spacing-sm);\n  align-items: center;\n}\n\n.dp-ph__search {\n  flex: 1;\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-sm);\n  outline: none;\n}\n\n.dp-ph__search:focus {\n  border-color: var(--dp-color-primary);\n}\n\n/* Buttons */\n.dp-ph__btn {\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  cursor: pointer;\n  background: var(--dp-color-background);\n  color: var(--dp-color-text);\n  white-space: nowrap;\n  transition: all 0.12s;\n}\n\n.dp-ph__btn:hover {\n  background: var(--dp-color-surface-hover);\n}\n\n.dp-ph__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.dp-ph__btn--primary {\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n  border-color: var(--dp-color-primary);\n}\n\n.dp-ph__btn--primary:hover {\n  background: var(--dp-color-primary-hover);\n}\n\n.dp-ph__btn--icon {\n  padding: var(--dp-spacing-xs);\n  font-size: var(--dp-font-size-md);\n  line-height: 1;\n}\n\n.dp-ph__btn--insert,\n.dp-ph__btn--select {\n  padding: 2px 8px;\n  font-size: 11px;\n  background: var(--dp-color-surface);\n  border-color: var(--dp-color-primary);\n  color: var(--dp-color-primary);\n}\n\n.dp-ph__btn--insert:hover,\n.dp-ph__btn--select:hover {\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n}\n\n/* Form header (shared across create modes) */\n.dp-ph__form-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--dp-spacing-sm);\n}\n\n.dp-ph__form-title {\n  font-size: var(--dp-font-size-sm);\n  font-weight: var(--dp-font-weight-bold);\n  color: var(--dp-color-text);\n}\n\n.dp-ph__form-desc {\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text-secondary);\n  margin: 0 0 var(--dp-spacing-sm);\n  line-height: 1.4;\n}\n\n.dp-ph__form-close {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--dp-color-text-secondary);\n  font-size: 12px;\n  padding: 2px 5px;\n  line-height: 1;\n  border-radius: var(--dp-border-radius-sm);\n}\n.dp-ph__form-close:hover { background: var(--dp-color-surface-hover); color: var(--dp-color-text); }\n\n/* Create form */\n.dp-ph__create-form {\n  background: var(--dp-color-surface);\n  padding: var(--dp-spacing-sm);\n  border-radius: var(--dp-border-radius-md);\n  margin-bottom: var(--dp-spacing-sm);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n}\n\n.dp-ph__form-row {\n  display: flex;\n  gap: var(--dp-spacing-xs);\n  margin-bottom: var(--dp-spacing-xs);\n  align-items: center;\n}\n\n.dp-ph__form-row:last-child {\n  margin-bottom: 0;\n}\n\n.dp-ph__input {\n  flex: 1;\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n}\n\n.dp-ph__input:focus {\n  border-color: var(--dp-color-primary);\n  outline: none;\n}\n\n.dp-ph__select {\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  background: var(--dp-color-background);\n}\n\n/* Searchable dropdown */\n.dp-dt-search {\n  position: relative;\n  margin-bottom: var(--dp-spacing-xs);\n}\n\n/* Trigger button (looks like a select) */\n.dp-dt-search__trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  background: var(--dp-color-background);\n  cursor: pointer;\n  text-align: left;\n}\n.dp-dt-search__trigger:hover {\n  border-color: var(--dp-color-primary);\n}\n.dp-dt-search__trigger-text {\n  color: var(--dp-color-text);\n}\n.dp-dt-search__trigger-placeholder {\n  color: var(--dp-color-text-secondary);\n}\n.dp-dt-search__trigger-arrow {\n  font-size: 8px;\n  color: var(--dp-color-text-secondary);\n  margin-left: 8px;\n}\n\n/* Dropdown panel */\n.dp-dt-search__dropdown {\n  position: absolute;\n  top: calc(100% + 2px);\n  left: 0;\n  right: 0;\n  z-index: 10;\n  background: var(--dp-color-background);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n  display: flex;\n  flex-direction: column;\n}\n\n/* Search input pinned at top */\n.dp-dt-search__search-box {\n  display: flex;\n  align-items: center;\n  padding: 6px 8px;\n  border-bottom: 1px solid var(--dp-color-border);\n  background: var(--dp-color-surface);\n}\n.dp-dt-search__search-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: var(--dp-font-size-xs);\n  background: transparent;\n  color: var(--dp-color-text);\n  padding: 2px 0;\n}\n.dp-dt-search__search-input::placeholder {\n  color: var(--dp-color-text-secondary);\n}\n.dp-dt-search__search-clear {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--dp-color-text-secondary);\n  font-size: 10px;\n  padding: 2px 4px;\n  line-height: 1;\n}\n.dp-dt-search__search-clear:hover {\n  color: var(--dp-color-text);\n}\n\n/* Scrollable list */\n.dp-dt-search__list {\n  max-height: 180px;\n  overflow-y: auto;\n}\n\n.dp-dt-search__empty {\n  padding: 12px;\n  color: var(--dp-color-text-secondary);\n  font-size: var(--dp-font-size-xs);\n  text-align: center;\n}\n\n.dp-dt-search__group-header {\n  padding: 5px 10px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--dp-color-text-secondary);\n  background: #f0f3f8;\n  border-bottom: 1px solid var(--dp-color-border);\n  position: sticky;\n  top: 0;\n}\n\n.dp-dt-search__item {\n  padding: 5px 10px 5px 20px;\n  cursor: pointer;\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  transition: background 0.1s;\n}\n.dp-dt-search__item:hover {\n  background: var(--dp-color-surface-hover);\n}\n.dp-dt-search__item--selected {\n  background: #e8f0fe;\n  font-weight: 600;\n  color: var(--dp-color-primary);\n}\n.dp-dt-search__item--selected:hover {\n  background: #d2e3fc;\n}\n.dp-dt-search__check {\n  font-size: 11px;\n  color: var(--dp-color-primary);\n}\n\n.dp-dt-search__backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9;\n}\n\n.dp-ph__checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text-secondary);\n  flex: 1;\n}\n\n/* Drag hint */\n.dp-ph__drag-hint {\n  text-align: center;\n  padding: var(--dp-spacing-xs);\n  font-size: 10px;\n  color: var(--dp-color-text-secondary);\n  background: var(--dp-color-surface);\n  border-radius: var(--dp-border-radius-sm);\n  margin-bottom: var(--dp-spacing-xs);\n}\n\n/* List */\n.dp-ph__list {\n  display: flex;\n  flex-direction: column;\n}\n\n.dp-ph__item {\n  display: flex;\n  align-items: center;\n  gap: var(--dp-spacing-xs);\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);\n  transition: background 0.12s;\n  cursor: grab;\n}\n\n.dp-ph__item:hover {\n  background: var(--dp-color-surface);\n}\n\n.dp-ph__item:active {\n  cursor: grabbing;\n}\n\n.dp-ph__item[draggable=\"true\"]:hover {\n  background: #e8eaf6;\n}\n\n.dp-ph__item--inserted {\n  background: #e8f5e9;\n  animation: dp-ph-flash 2s ease-out;\n}\n\n@keyframes dp-ph-flash {\n  0% { background: #c8e6c9; }\n  100% { background: transparent; }\n}\n\n/* Clickable + draggable items */\n.dp-ph__item--clickable {\n  cursor: grab;\n}\n.dp-ph__item--clickable:active {\n  cursor: grabbing;\n}\n.dp-ph__item--clickable:hover {\n  background: #e8f0fe;\n}\n\n/* Drag handle */\n.dp-ph__drag-handle {\n  color: var(--dp-color-text-secondary);\n  font-size: 12px;\n  line-height: 1;\n  opacity: 0.3;\n  flex-shrink: 0;\n  user-select: none;\n  letter-spacing: 1px;\n}\n\n.dp-ph__item:hover .dp-ph__drag-handle {\n  opacity: 0.7;\n}\n\n.dp-ph__item-main {\n  flex: 1;\n  min-width: 0;\n}\n\n.dp-ph__item-key {\n  display: block;\n  font-family: monospace;\n  font-size: var(--dp-font-size-xs);\n  font-weight: var(--dp-font-weight-semibold);\n  color: var(--dp-color-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dp-ph__item-label {\n  display: block;\n  font-size: 10px;\n  color: var(--dp-color-text-secondary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dp-ph__item-meta {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.dp-ph__item-value {\n  font-size: 10px;\n  color: var(--dp-color-text-secondary);\n  max-width: 60px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Type badges */\n.dp-ph__type-badge {\n  font-size: 9px;\n  font-weight: var(--dp-font-weight-bold);\n  padding: 1px 5px;\n  border-radius: var(--dp-border-radius-sm);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.dp-ph__type-badge--text    { background: #e3f2fd; color: #1565c0; }\n.dp-ph__type-badge--date    { background: #f3e5f5; color: #7b1fa2; }\n.dp-ph__type-badge--number  { background: #e8f5e9; color: #2e7d32; }\n.dp-ph__type-badge--money   { background: #fff8e1; color: #f57f17; }\n.dp-ph__type-badge--boolean { background: #fce4ec; color: #c62828; }\n.dp-ph__type-badge--address { background: #e0f2f1; color: #00695c; }\n.dp-ph__type-badge--list    { background: #ede7f6; color: #4527a0; }\n.dp-ph__type-badge--unknown { background: #f5f5f5; color: #757575; }\n\n.dp-ph__required-badge {\n  font-size: 9px;\n  font-weight: var(--dp-font-weight-bold);\n  padding: 1px 4px;\n  border-radius: var(--dp-border-radius-sm);\n  background: #ffebee;\n  color: #c62828;\n}\n\n.dp-ph__in-doc-badge {\n  font-size: 11px;\n  color: #2e7d32;\n  font-weight: bold;\n}\n\n/* Status */\n.dp-ph__status {\n  text-align: center;\n  padding: var(--dp-spacing-md);\n  color: var(--dp-color-text-secondary);\n  font-size: var(--dp-font-size-sm);\n}\n\n.dp-ph__error {\n  padding: var(--dp-spacing-sm);\n  background: #fde8e8;\n  color: var(--dp-color-error);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  margin-bottom: var(--dp-spacing-sm);\n}\n\n.dp-ph__empty {\n  text-align: center;\n  padding: var(--dp-spacing-lg);\n  color: var(--dp-color-text-secondary);\n  font-size: var(--dp-font-size-sm);\n}\n\n.dp-ph__summary {\n  margin-top: var(--dp-spacing-sm);\n  text-align: center;\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text-secondary);\n}\n\n/* ── Keyword dual-list ── */\n.dp-kw__dual {\n  display: flex;\n  gap: 6px;\n  margin-bottom: var(--dp-spacing-xs);\n}\n\n.dp-kw__col {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  overflow: hidden;\n}\n\n.dp-kw__col-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 3px 6px;\n  background: #f0f3f8;\n  font-size: 10px;\n  font-weight: var(--dp-font-weight-semibold);\n  color: var(--dp-color-text-secondary);\n  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);\n}\n\n.dp-kw__move-all {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 12px;\n  color: var(--dp-color-primary);\n  padding: 0 2px;\n  line-height: 1;\n}\n.dp-kw__move-all:hover { color: var(--dp-color-primary-hover); }\n\n.dp-kw__list {\n  flex: 1;\n  overflow-y: auto;\n  max-height: 150px;\n}\n\n.dp-kw__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 6px;\n  font-size: 11px;\n  cursor: pointer;\n  border-bottom: 1px solid #f0f0f0;\n  gap: 4px;\n  transition: background 0.1s;\n}\n.dp-kw__item:hover { background: #eef1fb; }\n.dp-kw__item:last-child { border-bottom: none; }\n\n.dp-kw__item--selected { background: #f0fff4; }\n.dp-kw__item--selected:hover { background: #e0f5e9; }\n\n.dp-kw__add  { color: var(--dp-color-primary); font-size: 14px; flex-shrink: 0; }\n.dp-kw__remove { color: #c62828; font-size: 10px; flex-shrink: 0; }\n\n/* ── Advanced Condition builder ── */\n.dp-ac__rows {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: var(--dp-spacing-xs);\n}\n\n.dp-ac__row {\n  background: #f8f9fc;\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  padding: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.dp-ac__row-label {\n  font-size: 10px;\n  font-weight: var(--dp-font-weight-bold);\n  color: var(--dp-color-primary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  flex-shrink: 0;\n}\n\n.dp-ac__row-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.dp-ac__select--ph,\n.dp-ac__select--op {\n  width: 100%;\n}\n\n.dp-ac__input--val {\n  flex: 1;\n}\n\n.dp-ac__then-row {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.dp-ac__remove-row {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #c62828;\n  font-size: 10px;\n  padding: 2px 4px;\n  border-radius: var(--dp-border-radius-sm);\n  flex-shrink: 0;\n}\n.dp-ac__remove-row:hover { background: #fde8e8; }\n\n.dp-ac__add-row {\n  background: none;\n  border: 1px dashed var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  color: var(--dp-color-primary);\n  font-size: var(--dp-font-size-xs);\n  padding: 4px 8px;\n  cursor: pointer;\n  text-align: center;\n  transition: all 0.12s;\n}\n.dp-ac__add-row:hover { background: var(--dp-color-surface); border-color: var(--dp-color-primary); }\n\n.dp-ac__else-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px;\n  background: #fffbf0;\n  border: var(--dp-border-width-thin) solid #ffe082;\n  border-radius: var(--dp-border-radius-sm);\n}\n\n/* Advanced condition list item (in section body) */\n.dp-ac__list-item {\n  cursor: default;\n}\n.dp-ac__list-item:hover {\n  background: var(--dp-color-surface);\n}\n\n/* ── Document Type section ── */\n.dp-dt__assigned-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n}\n.dp-dt__assigned-group {\n  font-size: 10px;\n  font-weight: var(--dp-font-weight-bold);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--dp-color-text-secondary);\n}\n.dp-dt__assigned-type {\n  flex: 1;\n  font-size: var(--dp-font-size-sm);\n  font-weight: var(--dp-font-weight-semibold);\n  color: #155724;\n  background: #d4edda;\n  padding: 2px 8px;\n  border-radius: var(--dp-border-radius-full);\n}\n.dp-dt__assigned-change {\n  background: none;\n  border: 1px solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  cursor: pointer;\n  color: var(--dp-color-primary);\n  font-size: 11px;\n  padding: 2px 7px;\n  line-height: 1.4;\n  white-space: nowrap;\n}\n.dp-dt__assigned-change:hover {\n  background: var(--dp-color-surface-hover);\n}\n\n.dp-dt__selected-chip {\n  background: #d4edda;\n  color: #155724;\n  font-weight: var(--dp-font-weight-semibold);\n}\n\n.dp-dt__group {\n  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);\n}\n.dp-dt__group:last-child { border-bottom: none; }\n\n.dp-dt__group-header {\n  padding: 5px 10px 3px;\n  font-size: 10px;\n  font-weight: var(--dp-font-weight-bold);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--dp-color-text-secondary);\n  background: #f8f9fc;\n}\n\n.dp-dt__item {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 12px;\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text);\n  cursor: pointer;\n  transition: background 0.1s;\n  border-bottom: 1px solid #f5f5f5;\n}\n.dp-dt__item:last-child { border-bottom: none; }\n.dp-dt__item:hover { background: #eef1fb; }\n\n.dp-dt__item--selected {\n  background: #e8f5e9;\n  font-weight: var(--dp-font-weight-semibold);\n  color: #1b5e20;\n}\n.dp-dt__item--selected:hover { background: #dcedc8; }\n\n.dp-dt__radio {\n  font-size: 12px;\n  color: var(--dp-color-primary);\n  flex-shrink: 0;\n  width: 14px;\n}\n\n.dp-dt__item-name { flex: 1; }\n\n.dp-dt__check {\n  color: #2e7d32;\n  font-size: 12px;\n  font-weight: bold;\n  flex-shrink: 0;\n}\n\n.dp-dt__clear-row {\n  padding: 6px 10px;\n  border-top: var(--dp-border-width-thin) solid var(--dp-color-border);\n  background: #f8f9fc;\n  text-align: right;\n}\n\n/* Picker list inside the selector form */\n.dp-dt__picker-list {\n  max-height: 220px;\n  overflow-y: auto;\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  margin-bottom: 2px;\n}\n\n/* Template Info Section */\n.dp-tpl__info {\n  padding: 8px 12px;\n}\n\n.dp-tpl__row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 5px 0;\n  border-bottom: 1px solid var(--dp-color-border);\n}\n.dp-tpl__row:last-child {\n  border-bottom: none;\n}\n\n.dp-tpl__label {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--dp-color-text);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  min-width: 55px;\n  padding-top: 2px;\n}\n\n.dp-tpl__value {\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text);\n  flex: 1;\n  font-weight: 500;\n}\n\n.dp-tpl__value--editable {\n  cursor: pointer;\n  border-radius: var(--dp-border-radius-sm);\n  padding: 1px 4px;\n  margin: -1px -4px;\n}\n.dp-tpl__value--editable:hover {\n  background: var(--dp-color-surface-hover);\n}\n\n.dp-tpl__edit-icon {\n  font-size: 9px;\n  color: var(--dp-color-primary);\n  margin-left: 4px;\n  font-weight: 600;\n  opacity: 0.6;\n}\n.dp-tpl__value--editable:hover .dp-tpl__edit-icon {\n  opacity: 1;\n}\n\n.dp-tpl__name-edit {\n  display: flex;\n  gap: 4px;\n  flex: 1;\n  align-items: center;\n}\n.dp-tpl__name-edit .dp-ph__input {\n  flex: 1;\n  font-size: 12px;\n  padding: 3px 6px;\n}\n.dp-tpl__name-edit .dp-ph__btn {\n  font-size: 10px;\n  padding: 3px 8px;\n}\n\n/* ── Conditional Section Visual Toggle ── */\n.dp-cond__item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);\n}\n.dp-cond__item:last-child {\n  border-bottom: none;\n}\n\n.dp-cond__badge {\n  font-size: 9px;\n  font-weight: var(--dp-font-weight-bold);\n  padding: 1px 6px;\n  border-radius: var(--dp-border-radius-sm);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  flex-shrink: 0;\n}\n.dp-cond__badge--if {\n  background: #d1fae5;\n  color: #065f46;\n}\n.dp-cond__badge--unless {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.dp-cond__key {\n  flex: 1;\n  font-family: monospace;\n  font-size: var(--dp-font-size-xs);\n  font-weight: var(--dp-font-weight-semibold);\n  color: var(--dp-color-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n/* CSS-only toggle switch */\n.dp-cond__toggle {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n.dp-cond__toggle input[type=\"checkbox\"] {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.dp-cond__toggle-slider {\n  display: inline-block;\n  width: 32px;\n  height: 18px;\n  background: #9CA3AF;\n  border-radius: 9px;\n  position: relative;\n  transition: background 0.2s;\n}\n.dp-cond__toggle-slider::after {\n  content: '';\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 14px;\n  height: 14px;\n  background: #fff;\n  border-radius: 50%;\n  transition: transform 0.2s;\n}\n.dp-cond__toggle input[type=\"checkbox\"]:checked + .dp-cond__toggle-slider {\n  background: #10B981;\n}\n.dp-cond__toggle input[type=\"checkbox\"]:checked + .dp-cond__toggle-slider::after {\n  transform: translateX(14px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
